import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { CallHistoryMethodAction, push } from 'connected-react-router';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Typography from '@components/basics/typography';

import SubscriptionInvoicesList from '../subscription-invoice-list';
import {
  EntitySubscription,
  ListSubscriptionsResponse,
} from '@common/types/subscription-manager/list-subscriptions-response';

interface SubscriptionsInvoicesCtrlProps {
  className?: string;
  noTitle?: boolean;
  subscription: EntitySubscription;
  category: keyof ListSubscriptionsResponse;
  handleClick: (
    category: keyof ListSubscriptionsResponse,
    id: string
  ) => CallHistoryMethodAction;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleClick: (category: keyof ListSubscriptionsResponse, id: string) =>
    dispatch(push(`/user/subscriptions/invoices/${category}/${id}`)),
});

const SubscriptionsInvoicesCtrl: React.FC<SubscriptionsInvoicesCtrlProps> = ({
  className,
  noTitle,
  category,
  subscription,
  handleClick,
}) => {
  const totalInvoices = subscription.subscriptions.reduce(
    (memo, s) => memo + s.invoiceCount,
    0
  );

  const invoices = subscription.subscriptions
    .map((s) => s.invoices)
    .flat()
    .sort((i) => Number(new Date(i.created_at)));

  return (
    <div className={`${className || ''}`}>
      {!noTitle ? (
        <Title className="mb-30" type="section-title" weight="400">
          <Translate id="USER_PROFILE.SUBSCRIPTION.INVOICES.TITLE" />
        </Title>
      ) : null}
      <SubscriptionInvoicesList invoices={invoices} />
      {!noTitle ? (
        <Typography
          className="mt-20"
          type="link"
          weight="700"
          onClick={() => handleClick(category, subscription.id)}
        >
          <Translate id="USER_PROFILE.SUBSCRIPTION.INVOICES.SEE_ALL" /> (
          {totalInvoices})
        </Typography>
      ) : null}
    </div>
  );
};

export default connect(
  null,
  mapDispatchToProps
)(styled(SubscriptionsInvoicesCtrl)``);

const Title = styled(Typography)`
  display: block;
`;
